import { useState } from 'react';
import { stayProperties } from '../pages/stayProperties';
import GuestSelector from './GuestSelector';
import DestinationSelector from './DestinationSelector';
import './Banner.css';

function Banner({
  eyebrow = 'JAMAICAN SOUL. WHEREVER YOU STAY.',
  title = <>A little escape.<br /><span className="banner__retreat-line">To reset your mind, body and soul</span></>,
  description = 'Take a moment to slow down, breathe deeply, and reconnect with yourself. A peaceful retreat to refresh your mind, restore your body, and renew your soul.',
  imageSrc = `${process.env.PUBLIC_URL}/images/st-mary-pagee-beach.jpg`,
  imageAlt = 'Pagee Beach in Port Maria, St Mary, Jamaica',
  action = { label: 'Explore our stays', href: '/stay' },
  onSearch,
}) {
  const [destination, setDestination] = useState('');
  const [guests, setGuests] = useState('');
  const guestLimit = stayProperties[destination]?.maxGuests || 10;
  const [guestError, setGuestError] = useState(false);
  const [destinationError, setDestinationError] = useState(false);

  function submitSearch(event) {
    event.preventDefault();
    if (!destination) { setDestinationError(true); return; }
    if (!guests) { setGuestError(true); return; }
    const criteria = Object.fromEntries(new FormData(event.currentTarget));
    if (onSearch) onSearch(criteria);
    else window.location.assign(`${stayProperties[criteria.destination].path}?${new URLSearchParams({ guests: criteria.guests })}#plan-your-stay`);
  }

  return (
    <section className="banner" aria-labelledby="hero-title">
      <div className="banner__grid">
        <div className="banner__content">
          <p className="banner__eyebrow">{eyebrow}</p>
          <h1 id="hero-title">{title}</h1>
          <p className="banner__description">{description}</p>
          <div className="banner__actions">
            <a className="banner__action" href={action.href}>{action.label}<span aria-hidden="true">↗</span></a>
            <a className="banner__secondary" href="/our-story">Meet JamRock Escape</a>
          </div>
          <div className="banner__feature">
            <div className="banner__feature-image"><img src={`${process.env.PUBLIC_URL}/images/bannersamll.jpg`} alt="Sunlight through oak trees in a Georgia garden" width="98" height="76" /></div>
            <div><strong>Three places. One warm welcome.</strong><p>Explore our Georgia, Jamaica and Oregon stays.</p></div>
          </div>
        </div>
        <div className="banner__visual" id="destination">
          <div className="banner__image-reveal"><img className="banner__image" src={imageSrc} alt={imageAlt} width="560" height="505" fetchPriority="high" /></div>
          <span className="banner__location">ST MARY · JAMAICA</span>
          <div className="banner__note"><strong>a yah suh nice</strong><span>Your escape starts here.</span></div>
          <a className="banner__image-credit" href="https://commons.wikimedia.org/wiki/File:Pagee_Beach_20231009_132626.jpg" target="_blank" rel="noopener noreferrer">Photo: CaptJayRuffins / Wikimedia Commons · CC BY-SA 4.0</a>
        </div>
      </div>
      <form className="booking-bar" id="booking" aria-label="Find a stay" onSubmit={submitSearch}>
        <div className="booking-bar__field booking-bar__destination"><span>Destination</span>
          <DestinationSelector value={destination} error={destinationError} describedBy={destinationError ? 'home-destination-error' : undefined} options={Object.values(stayProperties).map(property => ({ value: property.id, label: property.name, disabled: property.comingSoon }))} onChange={next => {
            setDestination(next);
            setDestinationError(false);
            if (Number(guests) > (stayProperties[next]?.maxGuests || 10)) setGuests('');
          }} />
          {destinationError && <span className="destination-selector__error" id="home-destination-error" role="alert">Choose a destination</span>}
        </div>
        <div className="booking-bar__field"><span>Guests</span><GuestSelector compact name="guests" value={Number(guests)} max={guestLimit} error={guestError} describedBy={guestError ? 'home-guest-error' : undefined} onChange={next => { setGuests(next ? String(next) : ''); setGuestError(false); }} />{guestError && <span className="guest-selector__error" id="home-guest-error" role="alert">Add at least one guest</span>}</div>
        <button className="booking-bar__submit" type="submit">Find a stay <span aria-hidden="true">↗</span></button>
      </form>
      <p className="banner__footnote">Landscape imagery is a destination concept; property photography will be added.</p>
    </section>
  );
}
export default Banner;
